/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * AX Studio Server
 * API Server for AX Studio
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AppCommonAuthRouterMeResponse,
  AuthInitRequest,
  AuthInitResponse,
  CallbackApiAuthCallbackProviderGetParams,
  HTTPValidationError,
  LogoutResponse
} from '../api.schemas';

import { customInstance } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * 로그인 시작 (state + auth_url 발급)

POST 요청으로 auth_url을 받아 클라이언트에서 리다이렉트합니다.
이 방식은 쿠키 설정 후 JS에서 리다이렉트하므로 쿠키가 정상 전달됩니다.
 * @summary Init Login
 */
export const initLoginApiAuthInitPost = (
    authInitRequest: AuthInitRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AuthInitResponse>(
      {url: `/api/auth/init`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authInitRequest, signal
    },
      options);
    }
  


export const getInitLoginApiAuthInitPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initLoginApiAuthInitPost>>, TError,{data: AuthInitRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof initLoginApiAuthInitPost>>, TError,{data: AuthInitRequest}, TContext> => {

const mutationKey = ['initLoginApiAuthInitPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initLoginApiAuthInitPost>>, {data: AuthInitRequest}> = (props) => {
          const {data} = props ?? {};

          return  initLoginApiAuthInitPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InitLoginApiAuthInitPostMutationResult = NonNullable<Awaited<ReturnType<typeof initLoginApiAuthInitPost>>>
    export type InitLoginApiAuthInitPostMutationBody = AuthInitRequest
    export type InitLoginApiAuthInitPostMutationError = HTTPValidationError

    /**
 * @summary Init Login
 */
export const useInitLoginApiAuthInitPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initLoginApiAuthInitPost>>, TError,{data: AuthInitRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initLoginApiAuthInitPost>>,
        TError,
        {data: AuthInitRequest},
        TContext
      > => {

      const mutationOptions = getInitLoginApiAuthInitPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * OAuth 콜백 처리 (state 검증 + 토큰 저장 + 세션 발급)
 * @summary Callback
 */
export const callbackApiAuthCallbackProviderGet = (
    provider: string,
    params: CallbackApiAuthCallbackProviderGetParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/api/auth/callback/${provider}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getCallbackApiAuthCallbackProviderGetQueryKey = (provider?: string,
    params?: CallbackApiAuthCallbackProviderGetParams,) => {
    return [
    `/api/auth/callback/${provider}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCallbackApiAuthCallbackProviderGetQueryOptions = <TData = Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>, TError = HTTPValidationError>(provider: string,
    params: CallbackApiAuthCallbackProviderGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCallbackApiAuthCallbackProviderGetQueryKey(provider,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>> = ({ signal }) => callbackApiAuthCallbackProviderGet(provider,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(provider), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CallbackApiAuthCallbackProviderGetQueryResult = NonNullable<Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>>
export type CallbackApiAuthCallbackProviderGetQueryError = HTTPValidationError


export function useCallbackApiAuthCallbackProviderGet<TData = Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>, TError = HTTPValidationError>(
 provider: string,
    params: CallbackApiAuthCallbackProviderGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>,
          TError,
          Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCallbackApiAuthCallbackProviderGet<TData = Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>, TError = HTTPValidationError>(
 provider: string,
    params: CallbackApiAuthCallbackProviderGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>,
          TError,
          Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCallbackApiAuthCallbackProviderGet<TData = Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>, TError = HTTPValidationError>(
 provider: string,
    params: CallbackApiAuthCallbackProviderGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Callback
 */

export function useCallbackApiAuthCallbackProviderGet<TData = Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>, TError = HTTPValidationError>(
 provider: string,
    params: CallbackApiAuthCallbackProviderGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof callbackApiAuthCallbackProviderGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCallbackApiAuthCallbackProviderGetQueryOptions(provider,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 현재 로그인된 사용자 정보 (비로그인 시 authenticated=false)
 * @summary Get Me
 */
export const getMeApiAuthMeGet = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AppCommonAuthRouterMeResponse>(
      {url: `/api/auth/me`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMeApiAuthMeGetQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }

    
export const getGetMeApiAuthMeGetQueryOptions = <TData = Awaited<ReturnType<typeof getMeApiAuthMeGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeApiAuthMeGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeApiAuthMeGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeApiAuthMeGet>>> = ({ signal }) => getMeApiAuthMeGet(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeApiAuthMeGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeApiAuthMeGetQueryResult = NonNullable<Awaited<ReturnType<typeof getMeApiAuthMeGet>>>
export type GetMeApiAuthMeGetQueryError = unknown


export function useGetMeApiAuthMeGet<TData = Awaited<ReturnType<typeof getMeApiAuthMeGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeApiAuthMeGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeApiAuthMeGet>>,
          TError,
          Awaited<ReturnType<typeof getMeApiAuthMeGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeApiAuthMeGet<TData = Awaited<ReturnType<typeof getMeApiAuthMeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeApiAuthMeGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeApiAuthMeGet>>,
          TError,
          Awaited<ReturnType<typeof getMeApiAuthMeGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeApiAuthMeGet<TData = Awaited<ReturnType<typeof getMeApiAuthMeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeApiAuthMeGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Me
 */

export function useGetMeApiAuthMeGet<TData = Awaited<ReturnType<typeof getMeApiAuthMeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeApiAuthMeGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeApiAuthMeGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 로그아웃 (세션 무효화)
 * @summary Logout
 */
export const logoutApiAuthLogoutPost = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LogoutResponse>(
      {url: `/api/auth/logout`, method: 'POST', signal
    },
      options);
    }
  


export const getLogoutApiAuthLogoutPostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutApiAuthLogoutPost>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof logoutApiAuthLogoutPost>>, TError,void, TContext> => {

const mutationKey = ['logoutApiAuthLogoutPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutApiAuthLogoutPost>>, void> = () => {
          

          return  logoutApiAuthLogoutPost(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutApiAuthLogoutPostMutationResult = NonNullable<Awaited<ReturnType<typeof logoutApiAuthLogoutPost>>>
    
    export type LogoutApiAuthLogoutPostMutationError = unknown

    /**
 * @summary Logout
 */
export const useLogoutApiAuthLogoutPost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutApiAuthLogoutPost>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logoutApiAuthLogoutPost>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getLogoutApiAuthLogoutPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    